import { render } from "./InsuranceClaimConfirmed.vue?vue&type=template&id=6c2a9e5b"
import script from "./InsuranceClaimConfirmed.vue?vue&type=script&lang=js"
export * from "./InsuranceClaimConfirmed.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__